import React from "react";

const Footer = () => (
  <footer className="bg-gray-900 py-8 border-t border-gray-800">
    <div className="max-w-7xl mx-auto px-6 text-center space-y-2">
      <div className="flex items-center justify-center space-x-3">
        <div className="w-8 h-8 rounded-full bg-gold flex items-center justify-center">
          <span className="text-brand-dark font-serif font-bold">S</span>
        </div>
        <span className="text-gold font-serif font-bold">Senshoha Systems</span>
      </div>
      <p className="text-gray-500 text-sm">
        &copy;&nbsp;{new Date().getFullYear()} Senshoha Systems. All rights
        reserved.
      </p>
      {/* Slogan in footer */}
      <p className="text-gold/70 text-xs italic mt-2">
        Intelligence in Every Inch
      </p>
    </div>
  </footer>
);

export default Footer;
